<template>
  <div class="tme">
    <template v-if="showsPhoto">
      <p class="tme-title">Foto de la entrega</p>
      <a :href="safeUrl" target="_blank" rel="noopener" class="tme-photo-link" @click.stop>
        <img :src="safeUrl" :alt="photoAlt" class="tme-photo" loading="lazy" @error="hasPhotoFailed = true">
      </a>
      <a :href="safeUrl" target="_blank" rel="noopener" class="tme-link" @click.stop>Ver en grande</a>
    </template>
    <p v-else-if="safeUrl" class="tme-fallback">
      <strong>Evidencia:</strong>
      <a :href="safeUrl" target="_blank" rel="noopener" @click.stop>ver enlace</a>
    </p>
    <p v-else class="tme-fallback">Evidencia no disponible</p>
  </div>
</template>

<script>
import { isImageEvidence } from './ticketMaterialsReview';
import { safeHttpUrl } from './safeUrl';

export default {
  name: 'TicketMaterialsEvidence',
  props: {
    url: { type: String, default: null },
    ticketId: { type: String, required: true },
  },
  data() {
    return { hasPhotoFailed: false };
  },
  computed: {
    safeUrl() { return safeHttpUrl(this.url); },
    showsPhoto() { return Boolean(this.safeUrl) && isImageEvidence(this.safeUrl) && !this.hasPhotoFailed; },
    photoAlt() { return `Foto de la entrega del pedido ${this.ticketId}`; },
  },
  watch: {
    url() { this.hasPhotoFailed = false; },
  },
};
</script>

<style scoped>
.tme { margin-top: 10px; }
.tme-title { margin: 0 0 6px; font-weight: 700; font-size: 12.5px; color: #1f2937; }
.tme-photo-link { display: block; }
.tme-photo {
  display: block;
  width: 100%;
  max-width: 360px;
  max-height: 240px;
  object-fit: cover;
  border-radius: 10px;
  border: 1px solid #eef1ef;
  background: #f4f5f4;
}
.tme-link { display: inline-block; margin-top: 6px; color: #01662E; font-weight: 600; font-size: 12.5px; }
.tme-fallback { margin: 0; }
.tme-fallback a { color: #01662E; font-weight: 600; }
</style>
